export default __webpack_public_path__ + "static/media/logo5.7c4537d9.svg";